
import React, { Component } from 'react';

import JWPlayer from './JWPlayer';

import './VideoOverlayJWPlayer.css';

const NAMESPACE = '[ VideoOverlayJWPlayer ]';

class VideoOverlayJWPlayer extends Component {

	constructor(props){
		super(props);

		this.state = {
			videoId : null,
			tracked10Played: false,
			tracked50Played: false,
			tracked90Played: false
		}

		this.handleMediaStartedRef = this.handleMediaStarted.bind(this);
		this.handleMediaPlayingRef = this.handleMediaPlaying.bind(this);
		this.handleMediaEndedRef = this.handleMediaEnded.bind(this);
	}

	componentWillMount(){
		this.setRandomVideo();

		// tracking
		// trackingWrapper('CRgame-ad-play');
	}

	setRandomVideo(){

		//console.log("================ VideoOverlayJWPlayer :: setRandomVideo() - start pool:", videoAdsPool);

		// let videoAdsPool = window.data.videoAdsPool;
		let videoAdsPool = 
		[
			"66ef101161a94ad0b10768fa2b36f8ed",
			"2bbe230e00e74642b6a52852c01a17cc",
			"3f67fc68e4eb47cfa8150c12655d9fb6",
			"6b265ccfed5a479690cac489c8c36d83",
			"be8c6fbfd0ce487e95f6f4414205be4d",
			"58c7d73ab63e415e9a807e0f16d39d86",
			"ef931375c7a34a38ad9f17cdcd91bcf0",
			"ed46456011e549ef95cc207a486d7834"
		];

		// get random from pool
		let video = videoAdsPool[Math.floor(Math.random() * videoAdsPool.length)];

		// remove chosen from pool
		const newVideoAdsPool = videoAdsPool.filter(x => x !== video);

		// if pool is empty, reset the pool with full list minus selected
		if(newVideoAdsPool.length === 0){
			// videoAdsPool = [...window.data.config.videoAd.videos];
			videoAdsPool = 
			[
				"66ef101161a94ad0b10768fa2b36f8ed",
				"2bbe230e00e74642b6a52852c01a17cc",
				"3f67fc68e4eb47cfa8150c12655d9fb6",
				"6b265ccfed5a479690cac489c8c36d83",
				"be8c6fbfd0ce487e95f6f4414205be4d",
				"58c7d73ab63e415e9a807e0f16d39d86",
				"ef931375c7a34a38ad9f17cdcd91bcf0",
				"ed46456011e549ef95cc207a486d7834"
			];

			// if total pool size is > 1, remove the selected so it does show back to back on next cycle
			// if(window.data.config.videoAd.videos.length > 1){
			// 	videoAdsPool = [...videoAdsPool.filter(x => x !== video)];
			// }
		}
		else {
			videoAdsPool = [...newVideoAdsPool];
		}

		//console.log("VideoOverlayJWPlayer :: setRandomVideo() -  selected video: ", video);
		//console.log("VideoOverlayJWPlayer :: setRandomVideo() -  end pool: ", videoAdsPool);

		this.setState({
			videoId : video
		});
	}

	handleMediaStarted() {
		
		console.log( NAMESPACE, 'handleMediaStarted()' );
		
	}
	
	handleMediaPlaying( event ) {
		// console.log( NAMESPACE, 'media playing ', 'time: '+event.currentTime, ' duration: '+event.duration );
		const {tracked10Played, tracked50Played, tracked90Played} = this.state;
		const percentage = event.currentTime / event.duration;
		
		if( percentage > 0.9 && !tracked90Played ) {
			console.log( NAMESPACE, 'track 90% played' );
			this.setState({tracked90Played: true});
		} 

		if( percentage > 0.5 && !tracked50Played ) {
			console.log( NAMESPACE, 'track 50% played' );
			this.setState({tracked50Played: true});
		} 

		if( percentage > 0.1 && !tracked10Played ) {
			console.log( NAMESPACE, 'track 10% played' );
			this.setState({tracked10Played: true});
		}
	}
	
	handleMediaEnded() {
		console.log( NAMESPACE, 'handleMediaEnded()' );
		
		this.closeOverlay();
	}

	closeOverlay(){
		this.props.handleVideoOverlayClose();
	}
	
	render(){
		const setup = {
			file: `https://content.uplynk.com/${this.state.videoId}.m3u8`,
			autostart: true
		}

		const onEvents = {
			complete: this.handleMediaEndedRef,
			time: this.handleMediaPlayingRef
		}

		return(
			<div id="videoOverlay">
				<div className="text">Chain Reaction Game Will Resume After This Video</div>
				<div className="video-player">
					<div id="jwplayer" />
					<JWPlayer
						playerId='jwplayer'
						setup={setup}
						onEvents={onEvents}
					/>
				</div>
				{
					//<div className="closeBtn" onClick={() => this.closeOverlay()}>x</div>
				}
			</div>
		);
	}
}

export default VideoOverlayJWPlayer;


// WEBPACK FOOTER //
// ./src/package-reward-ads-overlay/components/VideoOverlayJWPlayer.js